import { TFunction } from 'i18next'

import { PureCheckbox } from '../../../../common/ui/pure-checkbox/pure-checkbox'
import { PureDatePicker } from '../../../../common/ui/pure-date-picker/pure-date-picker'
import { PureDateRange } from '../../../../common/ui/pure-date-range/pure-date-range'
import { PureFileUpload } from '../../../../common/ui/pure-file-upload/pure-file-upload'
import { PureHeader } from '../../../../common/ui/pure-header/pure-header'
import { PureImageUpload } from '../../../../common/ui/pure-image-upload/pure-image-upload'
import { PureInput } from '../../../../common/ui/pure-input/pure-input'
import { PureInputRange } from '../../../../common/ui/pure-input-range/pure-input-range'
import { PureRadio } from '../../../../common/ui/pure-radio/pure-radio'
import { PureSelect } from '../../../../common/ui/pure-select/pure-select'
import { PureTextArea } from '../../../../common/ui/pure-text-area/pure-text-area'
import { CheckboxConfig } from '../components/form-items-droppable-config/checkbox-config'
import { DateRangeConfig } from '../components/form-items-droppable-config/date-range-config'
import { FileConfig } from '../components/form-items-droppable-config/file-config'
import { HeaderConfig } from '../components/form-items-droppable-config/header-config'
import { ImageConfig } from '../components/form-items-droppable-config/image-config'
import { InputFieldConfig } from '../components/form-items-droppable-config/input-field-config'
import { ListConfig } from '../components/form-items-droppable-config/list-config'
import { RangeConfig } from '../components/form-items-droppable-config/range-config'
import { FormBuilderConfig } from '../types/form-builder.types'

export enum FormItemType {
  Input = 'Input',
  Select = 'Select',
  InputNumber = 'InputNumber',
  Date = 'Date',
  DateRange = 'DateRange',
  Upload = 'Upload',
  ImageUpload = 'ImageUpload',
  Header = 'Header',
  NumberRange = 'NumberRange',
  Radio = 'Radio',
  Textarea = 'Textarea',
  Checkbox = 'Checkbox',
}

export const FormBuilderDroppableId = 'preview'

export const FormBuilderItemMap = {
  [FormItemType.Input]: PureInput,
  [FormItemType.Select]: PureSelect,
  [FormItemType.InputNumber]: PureInput,
  [FormItemType.Date]: PureDatePicker,
  [FormItemType.DateRange]: PureDateRange,
  [FormItemType.Upload]: PureFileUpload,
  [FormItemType.Header]: PureHeader,
  [FormItemType.NumberRange]: PureInputRange,
  [FormItemType.Radio]: PureRadio,
  [FormItemType.Textarea]: PureTextArea,
  [FormItemType.Checkbox]: PureCheckbox,
  [FormItemType.ImageUpload]: PureImageUpload,
}

export const FormBuilderItemConfigMap = {
  [FormItemType.Input]: InputFieldConfig,
  [FormItemType.Select]: ListConfig,
  [FormItemType.InputNumber]: InputFieldConfig,
  [FormItemType.Date]: InputFieldConfig,
  [FormItemType.DateRange]: DateRangeConfig,
  [FormItemType.Upload]: FileConfig,
  [FormItemType.Header]: HeaderConfig,
  [FormItemType.NumberRange]: RangeConfig,
  [FormItemType.Radio]: CheckboxConfig,
  [FormItemType.Textarea]: InputFieldConfig,
  [FormItemType.Checkbox]: CheckboxConfig,
  [FormItemType.ImageUpload]: ImageConfig,
}

export const FormBuilderItemConfigObjectMap = (t?: TFunction, config?: FormBuilderConfig) => ({
  [FormItemType.Input]: { label: '', placeholder: config?.placeholder ?? '', required: config?.required ?? false },
  [FormItemType.Select]: {
    label: '',
    placeholder: config?.placeholder ?? '',
    required: config?.required ?? false,
    options: config?.options ?? [],
  },
  [FormItemType.InputNumber]: { label: '', type: 'number', placeholder: config?.placeholder, required: config?.required ?? false },
  [FormItemType.Date]: { label: '', placeholder: config?.placeholder, required: false },
  [FormItemType.DateRange]: { label: '', from: config?.from ?? '', to: config?.to ?? '', required: false },
  [FormItemType.Upload]: { label: '', multiple: config?.multiple ?? false, required: false },
  [FormItemType.ImageUpload]: { label: '', required: false },
  [FormItemType.Header]: { label: '' },
  [FormItemType.NumberRange]: { label: '', from: config?.from ?? '', to: config?.to ?? '', required: false },
  [FormItemType.Radio]: { label: '', required: config?.required ?? false, options: config?.options ?? [] },
  [FormItemType.Textarea]: { label: '', placeholder: '', required: false },
  [FormItemType.Checkbox]: { label: '', required: config?.required ?? false, options: config?.options ?? [] },
})
